import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { getReleaseTrackFileVersionURLAPI } from "../releaseTrackFileVersionAPI";

export const useGetReleaseTrackFileVersionURL = (fileVersionId?: number) => {
  return useQuery<{ url: string | undefined }, Error>({
    queryKey: [QUERY_KEYS.GET_RELEASE_TRACK_FILE_VERSION_URL, fileVersionId],
    queryFn: () => getReleaseTrackFileVersionURLAPI(fileVersionId || 0),
    enabled: Boolean(fileVersionId),
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchInterval: false,
    retry: 0,
  });
};
